import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ValidatePolicy, ValidationResponse } from '@models/swagger';
import { ValidateVertiRelationsParams } from './service';

export enum ValidateVertiRelationsActions {
  Failure = '[Application Utilities ValidateVertiRelations] Failure',
  Request = '[Application Utilities ValidateVertiRelations] Request',
  Success = '[Application Utilities ValidateVertiRelations] Success',
}

export const ValidateVertiRelationsFailure = createAction(
  ValidateVertiRelationsActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const ValidateVertiRelationsRequest = createAction(
  ValidateVertiRelationsActions.Request,
  props<{ body: ValidatePolicy; parameters?: ValidateVertiRelationsParams }>()
);

export const ValidateVertiRelationsSuccess = createAction(
  ValidateVertiRelationsActions.Success,
  props<{ data: ValidationResponse }>()
);
